import { Container, Col, Row } from 'react-bootstrap';

import { useModalAnimation } from '@/hooks/useModalAnimation';
import { pageKey } from '@/routes';

import { Company, useCompanies } from '@/features/companies';
import { useItems } from '@/features/items/api';
import {
  AIModuleEntity,
  AIModuleTable,
  AddAIModule,
  EditAIModule,
  DeleteAIModule,
  EnableAIModule,
  ItemsEditAIModule,
} from '@/features/ai-modules';
import { MODAL_TYPES as MDT } from '@/types/options';

import Navbar from '../components/Navbar';

/**
 * AI modules management
 * @2025/04/23
 * @returns
 */
const AIModulesPage = () => {
  const {
    comnModalProps: commons,
    modalContex,
    activeModalType,
    activateModalBy: openBy,
  } = useModalAnimation();
  const { closeModal } = commons;
  const { data: companies } = useCompanies();
  const companyFilter = (c: Company) => c.status == 'ACTIVE';
  const activeCompanies: Company[] | undefined =
    companies?.filter(companyFilter);
  const { data: items } = useItems();

  return (
    <>
      <Container>
        {/* == row - 1: ai module table == */}
        <Row>
          {/* == left menu bar == */}
          <Col className="bg-dark sidebar d-flex flex-column">
            <Navbar activePage={pageKey.AIMODULES} />
          </Col>
          {/* == ai modules list */}
          <Col className="ms-6 me-4 ">
            <div
              className="d-flex flex-column align-items-center mt-4"
              style={{ minHeight: '100vh' }}
            >
              {/* Page Title */}
              <h3 className="text-center">AI Modules Management</h3>
              {/* button row */}
              <div
                className="d-flex justify-content-end w-100"
                style={{ gap: '30px' }}
              >
                {/* === Create New AI module === */}
                <button
                  className="btn btn-primary"
                  onClick={() => openBy(MDT.ADD_AI_MODULE)}
                >
                  Add New AI Module
                </button>
              </div>
              {/* === AI module list == */}
              <div className="mt-4 p-0 container">
                <AIModuleTable openBy={openBy} />
              </div>
            </div>
          </Col>
        </Row>
        {/* == row - 2:: other table... == */}
        <Row></Row>
      </Container>
      {/* == TODO: modals == */}
      <AddAIModule
        show={activeModalType == MDT.ADD_AI_MODULE}
        handleClose={closeModal}
        activeCompanies={activeCompanies || []}
      />
      <EditAIModule
        show={activeModalType == MDT.EDIT_AI_MODULE}
        handleClose={closeModal}
        activeCompanies={activeCompanies || []}
        aiModuleSelected={modalContex as AIModuleEntity}
      />
      <DeleteAIModule
        show={activeModalType == MDT.DELETE_AI_MODULE}
        handleClose={closeModal}
        aiModuleSelected={modalContex as AIModuleEntity}
      />
      <EnableAIModule
        show={activeModalType == MDT.ENABLE_AI_MODULE}
        handleClose={closeModal}
        aiModuleSelected={modalContex as AIModuleEntity}
      />
      <ItemsEditAIModule
        items={items}
        show={activeModalType == MDT.EDIT_ITEM_AI_MODULE}
        handleClose={closeModal}
        aiModuleSelected={modalContex as AIModuleEntity}
      />
    </>
  );
};

export default AIModulesPage;
